// Vues SAV : vues système, colonnes, filtres et tri (calculés côté navigateur sur toutes les demandes).
const today = () => new Date().toISOString().slice(0, 10);
export const DESINST = "Désinstallation";
export const viewStatuses = (opts, filters) => (filters?.type_sav === DESINST ? opts.desinst_statuses || [] : opts.statuses);
const name = (s) => [s.client?.prenom, s.client?.nom].filter(Boolean).join(" ");

export const BASE_COLUMNS = [
  { id: "reference", label: "Référence", get: (s) => s.reference },
  { id: "client", label: "Client", get: name },
  { id: "ville", label: "Ville", get: (s) => s.client?.ville },
  { id: "telephone", label: "Téléphone", get: (s) => s.client?.telephone },
  { id: "type_sav", label: "Type", get: (s) => s.values?.type_sav },
  { id: "probleme_materiel", label: "Matériel", get: (s) => s.values?.probleme_materiel },
  { id: "subcontractor", label: "Sous-traitant", get: (s) => s.subcontractor_name },
  { id: "employee", label: "Suivi par", get: (s) => s.employee_name },
  { id: "date_debut", label: "Début", get: (s) => s.values?.date_debut, date: true },
  { id: "date_rdv", label: "RDV", get: (s) => s.values?.date_rdv, date: true },
  { id: "date_dernier_contact", label: "Dernier contact", get: (s) => s.values?.date_dernier_contact, date: true },
  { id: "relances", label: "Relances", get: (s) => s.relances?.count ?? 0 },
  { id: "next_relance", label: "Prochaine relance", get: (s) => s.relances?.next_at, date: true },
  { id: "status", label: "Statut", get: (s) => s.status_label },
  { id: "created_at", label: "Créé le", get: (s) => s.created_at, date: true },
];
export const DEFAULT_COLUMNS = ["reference", "client", "ville", "type_sav", "probleme_materiel", "subcontractor", "employee", "date_debut", "date_rdv", "relances", "status"];

export function allColumns(fields) {
  const known = new Set(BASE_COLUMNS.map((c) => c.id));
  const extra = (fields || []).filter((f) => !known.has(f.id)).map((f) => ({ id: f.id, label: f.label, get: (s) => s.values?.[f.id], date: f.type === "date" }));
  return [...BASE_COLUMNS, ...extra];
}

const open = (s) => s.status !== "done";
export function systemViews(subcontractors) {
  const v = (id, name, filters, sort) => ({ id, name, filters, sort: sort || { key: "created_at", dir: "desc" }, columns: DEFAULT_COLUMNS, system: true });
  return [
    v("all", "Toutes les demandes", {}),
    v("en_cours", "En cours", { status: ["in_progress"] }),
    v("rdv", "RDV à venir", { rdv: "upcoming" }, { key: "date_rdv", dir: "asc" }),
    v("ouverture", "Ouverture", { status: ["pending"] }),
    v("relance1", "Relance 1", { relances: 1 }),
    v("relance2", "Relance 2", { relances: 2 }),
    v("relance3", "Relance 3", { relances: 3 }),
    v("termines", "Terminés", { status: ["done"] }, { key: "created_at", dir: "desc" }),
    v("ouverts", "SAV ouverts", { open: true }),
    v("desinstallation", "Désinstallations", { type_sav: DESINST }),
    v("en_retard", "En retard (relance 2 ou 3)", { late: true }),
    v("a_reattribuer", "À réattribuer", { alert: true }),
    ...subcontractors.map((s) => ({ ...v(`st_${s.id}`, s.name, { subcontractor_id: s.id }), group: "subcontractor" })),
  ];
}

export function applyFilters(items, f) {
  const q = (f.q || "").trim().toLowerCase();
  return items.filter((s) =>
    (!f.status?.length || f.status.includes(s.status))
    && (!f.type_sav || s.values?.type_sav === f.type_sav)
    && (!f.probleme_materiel || s.values?.probleme_materiel === f.probleme_materiel)
    && (!f.subcontractor_id || (f.subcontractor_id === "none" ? !s.subcontractor_id : s.subcontractor_id === f.subcontractor_id))
    && (!f.employee_id || s.employee_id === f.employee_id)
    && (f.relances == null || f.relances === "" || ((s.relances?.count ?? 0) === Number(f.relances) && open(s)))
    && (f.rdv !== "upcoming" || ((s.values?.date_rdv || "") >= today() && open(s)))
    && (f.rdv !== "none" || !s.values?.date_rdv)
    && (!f.open || open(s))
    && (!f.late || ((s.relances?.count ?? 0) >= 2 && open(s)))
    && (!f.alert || s.alert_open)
    && (!q || [s.reference, name(s), s.client?.ville, s.client?.telephone, s.subcontractor_name, s.values?.probleme_materiel, s.values?.description].join(" ").toLowerCase().includes(q)));
}

export function sortItems(items, sort, cols) {
  const c = cols.find((x) => x.id === sort?.key);
  if (!c) return items;
  const dir = sort.dir === "desc" ? -1 : 1;
  return [...items].sort((a, b) => {
    const x = c.get(a); const y = c.get(b);
    if (x == null || x === "") return 1;
    if (y == null || y === "") return -1;
    return (typeof x === "number" && typeof y === "number" ? x - y : String(x).localeCompare(String(y), "fr")) * dir;
  });
}
